import type { TFunction } from 'i18next';

import type { EPinpointRequestStatus, IDomainRecordStatus } from '@feathr/blackbox';

import type { TDomainRecord } from './DomainRecords.hooks';

/** Formats the records as tab-separated rows under a header, so they paste into a spreadsheet. */
export function getRecordsText(records: TDomainRecord[], t: TFunction): string {
  const header = [t('Type'), t('Host'), t('Value')].join('\t');
  const rows = records.map(({ name, type, value }) => [type, name, value].join('\t'));
  return [header, ...rows].join('\n');
}

/** Returns the record's status matched by type and value, or undefined when unreported. */
export function getRecordStatus(
  record: TDomainRecord,
  statuses: IDomainRecordStatus[],
): EPinpointRequestStatus | null | undefined {
  return statuses.find(({ type, value }) => type === record.type && value === record.value)?.status;
}
